import { pushPersonalAccountAnalytics } from "../../../utils";
export var handleLogOut = function handleLogOut(userType) {
  if (window) {
    var _window, _window$location, _window2, _window2$location;
    pushPersonalAccountAnalytics({
      button_text: 'выйти',
      account_type: userType
    });
    window.location.href = "".concat((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin, "/logout/?returnUrl=").concat((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href);
  }
};